angular.module('autoremind.communications.services', [])
    .factory('messagesService', ['$rootScope', '$http', '$q', '$filter', 'logger', '$enhancedHttp', '$timeout',
    function ($rootScope, $http, $q, $filter, logger, $enhancedHttp, $timeout) {
        var service = null;
        service = {
            inProgress: false,
            jobId: 0,
            messages: [],
            defOffset: 999999999,
            offset: 999999999,
            lastUpdate: 0,
            lastRegisteredId: 0,
            inView: false,
            loadingIndicator: {
                refCount: 0,
                state: false
            },
            clearModel: function () {
                service.inProgress = false;
                service.messages = [];
                service.lastUpdate = 0;
                service.lastRegisteredId = this.defOffset;
                service.jobId = 0;
                service.inView = false;
            },
            getUpdates: function (jobId, isOrderd) {
                service.offset = service.defOffset;
                service.getUpdatesRecursive(jobId, 'modified', isOrderd);
            },
            getUpdatesRecursive: function (jobId, mode, isOrderd) {
                service.getMessages(jobId, mode, isOrderd).then(function (data) {
                    // TODO: Stop if a full update requested
                    if (service.inView && data.messages !== undefined && data.messages.length >= data.limit) {
                        // TODO: no need to call again if lastRegisteredId reached and should be used
                        service.getUpdatesRecursive(jobId, mode, isOrderd);
                    }
                });
            },
            // Used by messaging-details-report and reports/communication/survey/survey
            getMessages: function (jobId, mode, isOrderd) {
                service.jobId = jobId;
                // TODO: Check if a request is already in progress and disable update mode if this is full mode (e.g. requested by scroll)
                var deferred = $q.defer();
                if (!service.inProgress) {
                    service.inProgress = true;
                    var url = '/servlets/messages/' + jobId + '/?offset=' + service.offset + '&mode=' + mode;
                    if (mode === 'modified') {
                        url += '&lastregisteredid=' + service.lastRegisteredId;
                        if (service.inView) {
                            mode = 'last';
                            url += '&uselastaslimit=true';
                        }
                    }
                    if (mode !== 'full' && service.lastUpdate !== undefined) {
                        url += '&lastupdate=' + service.lastUpdate;
                    }
                    console.log('url: ' + url);
                    $enhancedHttp({
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                        url: url
                    })
                        .then(function (data, status) {
                        if (data.messages !== undefined) {
                            // Only set time of last update when getting first batch of messages
                            if (service.offset === service.defOffset) {
                                service.lastUpdate = data.lastUpdate;
                            }
                            for (var i = 0; i < data.messages.length; i++) {
                                var message = data.messages[i];
                                // Only add new elements if not already in the list
                                var alreadyInList = false;
                                for (var j = 0; j < service.messages.length; j++) {
                                    if (service.messages[j].messageId == message.messageId) {
                                        alreadyInList = true;
                                        if (service.messages.length > 0 && service.messages[i] !== undefined) {
                                            if (service.messages[j].touched === undefined) {
                                                service.messages[j].touched = 1;
                                            }
                                            message.touched = service.messages[j].touched + 1;
                                        }
                                        // Replace with latest data from database
                                        service.messages[j] = message;
                                        break;
                                    }
                                }
                                if (!alreadyInList) {
                                    service.messages.push(message);
                                    if (message.messageId < service.lastRegisteredId) {
                                        service.lastRegisteredId = message.messageId;
                                    }
                                }
                                if (message.messageId < service.offset) {
                                    service.offset = message.messageId; // This will ensure that offset ends up to be the last message Id of the reply
                                }
                            }
                            service.inProgress = false;
                            deferred.resolve(data);
                            if (data.messages.length > 0) {
                                console.log('data.messages.length > 0');
                                // If data was updated/added then notify angular-inview to evaluate if bottom of list is visible
                                $timeout(function () {
                                    angular.element(window).trigger('checkInView');
                                });
                            }
                        }
                        else {
                            //
                            service.inProgress = false;
                            deferred.resolve(data);
                        }
                    }, function (data, status) {
                        service.inProgress = false;
                        logger.error('Error getting messages data from server');
                        deferred.reject(status);
                    });
                }
                else {
                    //TODO: should we reject promise?
                    logger.debug("skipping - in progress");
                }
                return deferred.promise;
            },
            persons: {
                personId: 0,
                messages: [],
                offset: 0,
                isCanBeLoaded: true,
                lastUpdate: 0,
                lastRegisteredId: 0,
                inView: false,
                loadingIndicator: {
                    refCount: 0,
                    state: false
                },
                clearModel: function () {
                    service.persons.inProgress = false;
                    service.persons.messages = [];
                    service.persons.lastUpdate = 0;
                    service.persons.lastRegisteredId = 0;
                    service.persons.jobId = 0;
                    service.persons.inView = false;
                }
            },
            // Used by reports/communication/messages/messages.directive
            getMessagesStatsByJobId: function (jobId) {
                var deferred = $q.defer();
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messages/jobs/' + jobId + '/stats/'
                }).then(function (data, status) {
                    deferred.resolve(data);
                }, function (data, status) {
                    //                        model.inProgress = false;
                    logger.error('Error getting messages stats from server');
                    deferred.reject(status);
                });
                return deferred.promise;
            },
            // Used by appointments-tables.directive
            getTotalMessagesByJobId: function (jobId) {
                var deferred = $q.defer();
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messages/jobs/' + jobId + '/totalmessages/'
                }).then(function (data, status) {
                    deferred.resolve(data);
                }, function (data, status) {
                    //                        model.inProgress = false;
                    logger.error('Error getting messages stats from server');
                    deferred.reject(status);
                });
                return deferred.promise;
            },
            messagingSorting: {
                sortby: 'messageCreated',
                order: true,
                offset: 0
            },
            getMessagingReport: function (date, messageTypes, loadingIndicator) {
                var url = '/servlets/messages/messagingreport/';
                url += $filter('date')(date.from, 'yyyy-MM-dd') + '/';
                url += $filter('date')(date.to, 'yyyy-MM-dd') + '/';
                url += '?categories=';
                if (messageTypes.length === 0 || (messageTypes.length === 1 && !messageTypes[0].value)) {
                    url += 'All';
                }
                else {
                    for (var i in messageTypes) {
                        url += messageTypes[i].value + (messageTypes.length > parseInt(i) + 1 ? ',' : '');
                    }
                }
                url += '&sortby=' + this.messagingSorting.sortby;
                url += '&order=' + (this.messagingSorting.order ? 'desc' : 'asc');
                url += '&offset=' + this.messagingSorting.offset;
                var self = this;
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url
                }, loadingIndicator)
                    .then(function (data) {
                    if (data.messagingReportGetLimit && data.messages.length > 0) {
                        self.messagingSorting.offset += parseInt(data.messagingReportGetLimit);
                    }
                    if (data.messages.length > 0) {
                        $timeout(function () {
                            angular.element(window).trigger('checkInView');
                        });
                    }
                    return data;
                });
            },
            //$filter('i18n')( '_messageViewFilters_all' )
            messagesViewFilters: [
                {
                    'value': 'all',
                    'name': 'View all states' // $filter('i18n')( '_messageViewFilters_all_' )  // Getting it from resource bundle is not working
                },
                {
                    'value': 'failed',
                    'name': 'View Failed only' // $filter('i18n')( '_messageViewFilters_failed_' ) // Getting it from resource bundle is not working
                }
            ],
            getMessageContentByMessageUuid: function (uuid) {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/gateway/log/messagedata/uuid/' + uuid + '/',
                }, this.loadingIndicator)
                    .then(function (data) {
                    console.log(data);
                    /*
                    for (var i = 0; i < data.messageData.length; i++) {
                        return data.messageData[i];
                    }
                    return false;*/
                    return data.messageData;
                });
            },
            getMessageContentByTrackingCode: function (code) {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/gateway/log/messagedata/trackingcode/' + code + '/',
                }, this.loadingIndicator)
                    .then(function (data) {
                    console.log(data);
                    return data.messageData;
                });
            },
            getMessagesTodayStats: function (category) {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messages/todaystats/' + category + '/' + '?now=' + Date.now(),
                    errorMessage: 'Failed getting messages stats for today from server.',
                    disableErrorDialog: true,
                });
            },
            getMessagesStatsToday: function () {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messages/messagessentstats/?period=today' + '&now=' + Date.now(),
                    errorMessage: 'Failed getting messages stats for today from server.',
                    disableErrorDialog: true,
                });
            },
            getMessagesStats7Days: function () {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messages/messagessentstats/?period=7' + '&now=' + Date.now(),
                    errorMessage: 'Failed getting messages stats for 7 days from today.',
                    disableErrorDialog: true,
                });
            },
            getMessagesStats30Days: function () {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messages/messagessentstats/?period=30' + '&now=' + Date.now(),
                    errorMessage: 'Failed getting messages stats for 30 days from today.',
                    disableErrorDialog: true,
                });
            }
        };
        $rootScope.$on('event:auth-logout', function () {
            logger.debug('messagesService.clear: killing service data');
            service.clearModel();
            service.persons.clearModel();
        });
        return service;
    }]);
//# sourceMappingURL=messages.services.js.map